import { connect } from 'react-redux'
import CommentsList from 'pages/comments/CommentList'

const mapStateToProps = state => ({
  encryptionKeysLoaded: state.user.encryptionKeysLoaded,
  isFiltered: state.annotations.isFiltered,
  isAnnotationsLoaded: state.placeholders.isAnnotationsLoaded,
  isCommentsLoaded: state.annotations.isCommentsLoaded
})

export default connect(mapStateToProps, null)(CommentsList)
